<div class="editor-container">
  <div class="editor-header">
    <h2>{{title}} </h2>
    <button [attr.guide]="'profile-editor-dialog-btn-1' + '__' + sanitizedUrl" mat-icon-button (click)="closeDialog()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  
  <div  class="editor-content">

   <img
  #imgRef
  [src]="uploadedImageUrl || data?.imageUrl || 'assets/images/logo/no-image.png'"
    onerror="this.src='assets/images/products/placeholder.jpg';"
  alt="Profile picture"
  class="profile-image-preview"
/>
  </div>

  <div class="editor-actions" fxLayoutGap="10px" *ngIf="showUpload">
    <button [attr.guide]="'profile-editor-dialog-btn-2' + '__' + sanitizedUrl" mat-stroked-button color="warn" (click)="deleteImage()" [disabled]="!data?.imageUrl && !uploadedImageUrl">
      <mat-icon>delete_outline</mat-icon>
      Remove picture
    </button>

     <button [attr.guide]="'profile-editor-dialog-btn-3' + '__' + sanitizedUrl" mat-raised-button color="primary" (click)="onSaveChanges()" [disabled]="uploadInProgress">
      Save Changes
    </button>
    <!-- <button [attr.guide]="'profile-editor-dialog-btn-4' + '__' + sanitizedUrl" mat-stroked-button color="primary" (click)="triggerFileInput(fileInput)">
      <mat-icon>upload</mat-icon>
      Upload new picture
    </button> -->
  </div>

  <!-- Only show Save/Cancel after a new upload -->

  <div *ngIf="!showUpload" class="editor-save-actions" fxLayoutGap="10px">
   

     <button [attr.guide]="'profile-editor-dialog-btn-5' + '__' + sanitizedUrl" mat-stroked-button color="primary" (click)="triggerFileInput(fileInput)">
      <mat-icon>upload</mat-icon>
      Upload new picture
    </button>
  
  </div>
  
  <input [attr.guide]="'profile-editor-dialog-inp-6' + '__' + sanitizedUrl" type="file" #fileInput hidden (change)="onFileSelected($event)" accept="image/*" />

  <div *ngIf="uploadInProgress">
    <mat-progress-bar mode="determinate" [value]="uploadProgress"></mat-progress-bar>
  </div>
</div>
